import { capitalize } from 'lodash'

export const capitalizeText = (text: string): string => {
  try {
    return capitalize(text)
  } catch {
    return text
  }
}
